import React, { useEffect, useState } from "react";
import CustomCircleProfilePic from "../../../common/components/CustomCircleProfilePic";
import { Box } from "@mui/system";
import CustomEditCard from "../../../common/components/CustomEditCard/CustomEditCard";
import { Avatar, Typography } from "@mui/material";
interface propsType {
  trans?: any;
}
const BestPerfomerPresenter: React.FC<propsType> = ({ trans }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  return (
    <div>
      <CustomEditCard
        card_title={trans("Best Performer")}
        card_height="310px"
        showEditButton={false}
      >
        <Box style={{ marginBottom: "24px" }} />

        <Typography
          style={{
            color: "#2196F3",
            width: "2.8em",
            height: "auto",
            alignSelf: "center",
            textAlign: "center",
            borderRadius: "10px",
            padding: "2px",
            backgroundColor: "#FAFAFA",
            marginTop: "-1em",
          }}
        >
          2022
        </Typography>

        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CustomCircleProfilePic profilePic={{ award: "", pic: "" }} />
          <Typography
            style={{
              marginTop: "0.5em",
              fontWeight: "bold",
              fontFamily: "Lato",
              fontSize: "1em",
              color: "#000000",
            }}
          >
            Congratulations! <span style={{ color: "#7C0E6F" }}>Nazir</span>
          </Typography>
          <Typography
            style={{
              textAlign: "center",
              fontFamily: "Lato",
              fontSize: "0.85em",
              color: "#8181A5",
            }}
          >
            We know you have worked hard for this accomplishment and we truly
            appreciate your dedication.
          </Typography>
          <Box
            style={{
              border: "1px solid #4CAF50",
              marginTop: "0.5em",
              padding: "5px",

              borderRadius: "25%",
            }}
          >
            <Typography
              style={{
                fontFamily: "Lato",
                fontWeight: "bold",
                fontSize: "1.5em",
                color: "#4CAF50",
              }}
            >
              95%
            </Typography>
          </Box>
        </Box>
      </CustomEditCard>

      {/* Add Employee Skill Modal */}
    </div>
  );
};

export default BestPerfomerPresenter;
